module.exports = __webpack_public_path__ + "static/media/ma-1.f4484b79.svg";